import { render, staticRenderFns } from "./dsn-menutree.vue?vue&type=template&id=2f007b1e&"
import script from "./dsn-menutree.vue?vue&type=script&lang=js&"
export * from "./dsn-menutree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports